import { computed, toRef, type MaybeRef, type ComputedRef } from "vue";
import { Company } from "@/types";
import { FEATURE_FLAGS } from "@/constants";

/**
 * Composable for checking and managing company feature flags
 *
 * @param company - The company object (can be reactive or plain)
 * @returns Object with utilities for feature flag management
 */
export function useFeatureFlags(company: MaybeRef<Company | null | undefined>) {
  const companyRef = toRef(company);

  /**
   * Check if the company has a specific feature flag enabled
   *
   * @param flagKey - The feature flag key to check
   * @returns Reactive boolean indicating if the flag is enabled
   */
  const hasFlag = (
    flagKey: keyof typeof FEATURE_FLAGS
  ): ComputedRef<boolean> => {
    return computed(() => {
      const currentCompany = companyRef.value;
      if (!currentCompany?.feature_flags) return false;
      return currentCompany.feature_flags[flagKey] === true;
    });
  };

  return {
    hasFlag,
  };
}
